import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ErrorProvider } from "./contexts/ErrorContext";
import { AppRouter } from "./router";
import ErrorBoundary from "./components/ErrorBoundary";
import { useErrorHandling } from "./hooks/useErrorHandling";

function AppContent() {
  // Set up global error listeners
  useErrorHandling();

  return <AppRouter />;
}

export default function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <ErrorProvider>
          <AuthProvider>
            <AppContent />
          </AuthProvider>
        </ErrorProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
